import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { MaintenanceWorkOrderType } from '../models/maintenance-work-order/maintenance-work-order-type';

@Injectable({ providedIn: 'root' })
export class MaintenanceWorkOrderTypeProxyService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.proxyUrls.ascApi + '/api/v1/maintenance-work-order-type';

  getAll(): Observable<ApiResponse<MaintenanceWorkOrderType[]>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrderType[]>>(`${this.baseUrl}/all`);
  }

  getById(id: string): Observable<ApiResponse<MaintenanceWorkOrderType>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrderType>>(`${this.baseUrl}/${id}`);
  }

  create(entity: MaintenanceWorkOrderType): Observable<ApiResponse<MaintenanceWorkOrderType>> {
    return this.httpClient.post<ApiResponse<MaintenanceWorkOrderType>>(this.baseUrl, entity);
  }

  update(id: string, entity: MaintenanceWorkOrderType): Observable<ApiResponse<MaintenanceWorkOrderType>> {
    return this.httpClient.put<ApiResponse<MaintenanceWorkOrderType>>(`${this.baseUrl}/${id}`, entity);
  }

  delete(id: string): Observable<ApiResponse<null>> {
    return this.httpClient.delete<ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}
